import React from "react";
import { Flex } from "rebass";

import { ConnectPlaceholder } from "../components/ConnectPlaceholder";
import { DropboxSVG } from "../../svg/DropboxSVG";
import { DROPBOX_PATH, HEIGHT, TARGET, WIDTH } from "../../../constants/dropbox";
import getDropbox from "../../../../api/dropbox";

const dropbox = getDropbox();

const openPopup = () => {
  const { top: { outerWidth, outerHeight, screenX, screenY }, location: { origin } } = window;
  const url = dropbox.getAuthenticationUrl(`${origin}/${DROPBOX_PATH}`, undefined, "code");
  const top = screenY + (outerHeight - HEIGHT) / 2;
  const left = screenX + (outerWidth - WIDTH) / 2;
  const features = `dialog=yes,dependent=yes,scrollbars=yes,height=${HEIGHT},width=${WIDTH},top=${top},left=${left}`;

  window.open(url, TARGET, features);
};

export const Connect: React.FC = () => (
  <Flex
    height="100%"
    justifyContent="center"
    alignItems="center"
  >
    <ConnectPlaceholder
      providerName="Dropbox"
      icon={DropboxSVG}
      onClick={openPopup}
    />
  </Flex>
);
